// This file is autogenerated. DO NOT MODIFY

export const ILLUSTRATIONS = {
  AppleStore: 'apple-store',
  Binoculars: 'binoculars',
  GoogleStore: 'google-store',
  MagnifyingGlass: 'magnifying-glass'
} as const;

export type Illustrations = typeof ILLUSTRATIONS;
export type IllustrationName = Illustrations[keyof Illustrations];
